
export function byId<T extends HTMLElement>(id: string, nodeName: string = ''): T | null {
  const elem = document.getElementById(id)
  if (!elem) {
    return null
  }
  if (nodeName && elem.nodeName.toLowerCase() != nodeName) {
    return null
  }
  return <T> elem
}

export function byIdOrThrow<T extends HTMLElement>(id: string, nodeName: string = ''): T {
  const elem = byId<T>(id, nodeName)
  if (!elem) {
    throw new Error(`Element not found: #${id}`)
  }
  return elem
}
